export default __webpack_public_path__ + "static/media/TUC - Vintage Worm 1_1.a34b9807.wav";